// src/components/SPanel/Home/HomeTile.jsx
//
// Cadrul unui widget: cardul (link, buton sau simplu bloc), antetul cu iconiță
// și titlu, cifrele care cresc. Cardul e „container” CSS: mărimile din interior
// se potrivesc pe pătratul widget-ului (vezi _studentHome.scss).

import React from "react";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

import { useCountUp } from "./homeHooks";

export function Icon({ src }) {
   return <ReactSVG src={src} className="wd-icon react-icon" aria-hidden="true" />;
}

export function CountUp({ value, duration }) {
   return <>{useCountUp(value, duration)}</>;
}

export function Tile({ id, size, to, onClick, tone, className = "", label, children }) {
   const cls =
      `hw__card wd wd--${id} wd--s-${size}` +
      (tone ? ` wd--${tone}` : "") +
      (className ? ` ${className}` : "");
   if (to) {
      return (
         <Link to={to} className={cls} aria-label={label}>
            {children}
         </Link>
      );
   }
   if (onClick) {
      return (
         <button type="button" className={cls} onClick={onClick} aria-label={label}>
            {children}
         </button>
      );
   }
   return (
      <section className={cls} aria-label={label}>
         {children}
      </section>
   );
}

export function Head({ icon, title, extra, action }) {
   return (
      <div className="wd__head">
         {icon && (
            <span className="wd__icon">
               <Icon src={icon} />
            </span>
         )}
         <h3 className="wd__title">{title}</h3>
         {extra}
         {action && (
            <Link to={action.to} className="wd__action">
               {action.label}
               <span aria-hidden="true">→</span>
            </Link>
         )}
      </div>
   );
}

export function Skeleton() {
   return <div className="wd-skeleton" aria-label="Se încarcă" />;
}
